<template>
  <v-form v-model="valid" :ref="this.$options.name">
    <h5>{{ $t('registration.subtitles.playerName') }}</h5>
    <v-layout wrap justify-space-between>
      <v-flex xs12 sm5 class="pr-2">
        <v-text-field
          ref="fname"
          :value="value.fname"
          @input="update('fname', $refs.fname.lazyValue)"
          :rules="fnameRules"
          :label="$t('registration.playerForm.fname')"
          required
        />
      </v-flex>
      <v-flex xs6 sm2 class="pr-2">
        <v-text-field
          ref="mname"
          :value="value.mname"
          @input="update('mname', $refs.mname.lazyValue)"
          :rules="mnameRules"
          :label="$t('registration.playerForm.mname')"
          required
        />
      </v-flex>
      <v-flex xs12 sm5>
        <v-text-field
          ref="lname"
          :value="value.lname"
          @input="update('lname', $refs.lname.lazyValue)"
          :rules="lnameRules"
          :label="$t('registration.playerForm.lname')"
          required
        />
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
export default {
  name: 'PlayerName',
  props: {
    value: Object
  },
  data() {
    return {
      valid: false,
      fnameRules: [ (v) => !!v || this.$t('validation.nameRequired') ],
      mnameRules: [ ],
      lnameRules: [ (v) => !!v || this.$t('validation.nameRequired') ]
    }
  },
  methods: {
    update (key, value) {
      this.$emit('input', { ...this.value, [key]: value })
    },
    validate () {
      return this.$refs[this.$options.name].validate()
    }
  }
}
</script>

<style scoped>

</style>